<template>
    <div class="input-group">
        <button @click="nearby()" class="btn btn-light" type="button" title="Nearby search"><i class="fad fa-location"></i></button>
        <input v-on:keyup.enter="search()" placeholder="Search..." type="search" ref="search" v-model="q"
               class="form-control">
        <button @click="search()" class="btn btn-light" type="button" title="Search"><i class="fal fa-search"></i></button>
    </div>
</template>

<script>
export default {
    name: "search-input",


    data() {
        return {q: ''}
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        let q = urlParams.get('q')
        if (q) {
            this.q = q;
        }
        console.log('search');
        if (window.$userID) {
            $api.auth.isOnline();
            setInterval(() => {
                $api.auth.isOnline();
            },1000*600);
        }
    },
    methods: {
        toggle() {
            if (window.innerWidth <= 567) {
                const menuToggle = document.getElementById('topNavbarNavDropdown')
                const bsCollapse = new bs.Collapse(menuToggle, {toggle: false})
                bsCollapse.toggle();
            }
        },

        search() {
            if (this.q && this.q.trim().length >= 3) {
                const mountPoint = document.querySelector('#app');
                const params = new URLSearchParams('q=' + this.q);
                let url = '/search?q=' + params.get('q');
                if (mountPoint) {
                    window.router.push(url)
                    this.toggle();
                } else {
                    window.open(url, "_self")
                }
            }
        },
        nearby() {
            const mountPoint = document.querySelector('#app');
            const params = new URLSearchParams('q=' + this.q);
            let url = '/escorts/nearby';
            if (mountPoint) {
                window.router.push(url)
                this.toggle();
            } else {
                window.open(url, "_self")
            }
        }
    }
}
</script>

<style lang="scss" scoped>

@media (max-width: 575.98px) {
    input {
        font-size: 25px;
    }
}

.btn{
    min-width: 40px;
}
input {
    border-color: white;
}
</style>
